import { render, staticRenderFns } from "./companyQualification.vue?vue&type=template&id=4f0df0e0&scoped=true&"
import script from "./companyQualification.js?vue&type=script&lang=js&"
export * from "./companyQualification.js?vue&type=script&lang=js&"
import style0 from "./companyQualification.vue?vue&type=style&index=0&id=4f0df0e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0df0e0",
  null
  
)

export default component.exports